import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as _ from 'lodash-es';

import { StateService } from '@uirouter/angular';
import { TrackeritemRest } from '../../../../plugins/tracker/services/trackeritem.rest';
import { TrackeritemService } from '../../../../plugins/tracker/services/trackeritem.service';
import { TrackerService } from '../../../../plugins/tracker/services/tracker.service';
import { TrackerFilterService } from '../../../../plugins/tracker/services/tracker.filter.service';
import { TrackeritemAddModalComponent } from '../../../../plugins/tracker/trackerItemAdd/trackerItemAddModal/trackeritem.add.modal.component';
import { TrackeritemEditModalComponent } from '../../../../plugins/tracker/edit/trackerItemEditModal/trackeritem.edit.modal.component';

import { KanbanStrategyService } from '../../../../plugins/tracker/services/kanban.strategy.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { FrsReleaseHelper } from '../../../../plugins/frs/services/frs.release.helper.service';
import { BoardService } from '../board.service';
import { GfTitleService } from '../../../services/core.title.service';

@Component({
    selector: 'board-view',
    template: require('./board.view.component.html')
})
export class BoardViewComponent implements OnInit {

    @Input() project: any = null;
    @Input() projectMenu: any = null;
    @Input() board: any = null;

    public $state: StateService;

    protected trackeritems: any = [];
    private tracker: any = null;

    protected cardSizes = [10, 20, 50, 100];
    protected collapseOptions: any = null;
    protected collapseOption: any;
    protected kanbanOptions: any;

    private projectTrackers: any;
    private acls: any;
    protected maxCards = 20;

    private sprint: any;
    protected dataSourceParams: any = {};

    constructor(
        private stateService: StateService,

        private trackeritemRest: TrackeritemRest,
        private trackerService: TrackerService,
        private trackeritemService: TrackeritemService,
        private trackerFilterService: TrackerFilterService,

        private frsReleaseHelper: FrsReleaseHelper,

        private kanbanStrategyService: KanbanStrategyService,
        private boardService: BoardService,

        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private modalService: NgbModal,

        private window: Window,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.$state = this.stateService;
        this.collapseOptions = this.boardService.collapseOptions;

        let trackerId: any = 0;

        trackerId = this.board?.config?.query?.tracker ?? null;

        this.projectTrackers = _.get(this.project, 'rel.permissions.trackers', {});
        this.acls = this.trackerService.acl.get(this.projectTrackers, trackerId);
        this.maxCards = _.get(this.stateService.params, 'max_cards', 20);

        this.canUpdate = _.memoize(
            (trackerId) => {
                return this.trackerService.acl.get(this.projectTrackers, trackerId).canUpdate;
            }
        )

        this.canAssign = _.memoize(
            (trackerId) => {
                return this.trackerService.acl.get(this.projectTrackers, trackerId).canAssign;
            }
        )

        if (trackerId) {
            this.trackerService.load(trackerId)
                .then((result) => {
                    this.tracker = result;
                    this.kanbanOptions = this.getKanbanOptions();
                    this.collapseOption = {
                        columns: this.collapseOptions[this.kanbanOptions.collapseEmpty.columns],
                        rows: this.collapseOptions[this.kanbanOptions.collapseEmpty.rows]
                    };
                });
        } else {
            this.kanbanOptions = this.getKanbanOptions();
            this.collapseOption = {
                columns: this.collapseOptions[this.kanbanOptions.collapseEmpty.columns],
                rows: this.collapseOptions[this.kanbanOptions.collapseEmpty.rows]
            };
        }

        this.titleService.setTitle(this.board.boardName, 'Planning Board');

        this.dataSourceParams = { query: this.board?.config?.query?.id ?? null, tracker: this.board?.config?.query?.tracker ?? null };

        this.refresh();
    };


    private canUpdate = _.memoize(
        (trackerId) => {
            return this.trackerService.acl.get(this.projectTrackers, trackerId).canUpdate;
        }
    );

    private canAssign = _.memoize(
        (trackerId) => {
            return this.trackerService.acl.get(this.projectTrackers, trackerId).canAssign;
        }
    );

    setCollapseEmpty(bin, value) {
        if (this.kanbanOptions.collapseEmpty[bin] != value) {
            _.set(this.board, 'config.collapseEmpty.' + bin, value);
            this.kanbanOptions = this.getKanbanOptions();
            this.collapseOption[bin] = this.collapseOptions[this.kanbanOptions.collapseEmpty[bin]];
        }
    }

    setCardSize(newSize) {
        if (newSize && this.maxCards != newSize) {
            this.maxCards = newSize;
            this.stateService.go('.', { max_cards: this.maxCards }, { reload: false })
                .then(() => this.refresh());
        }
    }

    refresh() {
        this.trackeritems = false;

        switch (this.board.section) {
            case 'query':
                this.fetchTrackeritemsForQuery(this.board?.config?.query?.id ?? null)
                    .then((items) => {
                        this.trackeritems = items;
                    });
                break;

            case 'sprint':
                this.fetchTrackeritemsForSprint(this.board?.config?.sprint?.id ?? null)
                    .then((items) => {
                        this.trackeritems = items;
                    });
                break;

            case 'release':
                this.fetchTrackeritemsForRelease(this.board?.config?.release?.id ?? null)
                    .then((items) => {
                        this.trackeritems = items;
                    });
                break;
        }
    }

    editCard = (card) => {
        card.tracker = this.tracker;
        this.openTrackeritemEditModal(card);
    };

    openTrackeritemEditModal(item) {
        const modalRef = this.modalService.open(TrackeritemEditModalComponent);

        modalRef.componentInstance.trackeritem = item;
        modalRef.componentInstance.tracker = item.tracker;
        modalRef.componentInstance.allowUpdate = this.canUpdate(item.tracker.id);
        modalRef.componentInstance.allowAssignment = this.canAssign(item.tracker.id);
        modalRef.componentInstance.close.subscribe((result) => {
            modalRef.close();
            this.refresh();
        });
    }

    customTrackerItem(data, original) {
        Object.assign(original, data);
        return data;
    }

    openTrackerItemAddModal = (col: any, row?: any) => {
        if (!this.tracker) {
            this.uiService.message.showError(
                this.gfTranslateService.translate('Add Tracker Item')
            );
            return;
        }

        if (!this.projectMenu || _.isEmpty(this.projectMenu)) {
            this.uiService.message.showWarning(
                this.gfTranslateService.translate('Add Tracker Item')
            );
        }

        let addModalParams: any = {
            section: '',
            id: 'ti-add',
            title: "Add new item",
            subtitle: "",
            footerMessage: ""
        };

        let extraData: any = {
            'extraFields': {}
        };

        if (this.board?.config?.columnSource?.alias ?? null) {
            extraData.extraFields[this.board.config.columnSource.alias] = { fieldData: col };
        }

        if (this.board?.config?.rowSource?.alias ?? null) {
            extraData.extraFields[this.board.config.rowSource.alias] = { fieldData: row };
        }

        const modalRef = this.modalService.open(TrackeritemAddModalComponent);

        modalRef.componentInstance.tracker = this.tracker;
        modalRef.componentInstance.trackers = this.projectTrackers;
        modalRef.componentInstance.customTrackerItem = this.customTrackerItem;
        modalRef.componentInstance.extraData = extraData;
        modalRef.componentInstance.params = addModalParams;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.onCreate.subscribe((event: any) => {
            this.refresh();
            if (!event?.keepOpen) {
                modalRef.close();
            }
        });
        modalRef.componentInstance.onClose.subscribe(() => {
            modalRef.close();
        });
    };

    moveCard = (params) => {
        let { card, col, row } = params;
        if (!this.kanbanStrategyService.isChanged(this.kanbanOptions, card, col, row)) return false;

        card.updating = true;
        this.trackeritemService.saveTi(
            card,
            this.kanbanStrategyService.getUpdateObject(this.kanbanOptions, col, row)
        ).then(
            (ti: any) => {
                // Apply the same update to the existing ti in the list
                this.trackeritems = _.map(
                    this.trackeritems,
                    (item) => {
                        if (item.id == ti.id) {
                            return this.updateTrackerItem(this.kanbanOptions, item, ti);
                        }
                        return item;
                    }
                );
            },
            (response) => {
                this.uiService.message.showWarning(
                    this.kanbanStrategyService.getKanbanMessage(
                        _.get(response, 'data', {}), this.tracker
                    ),
                    this.gfTranslateService.translate("Update Failed")
                );
            }
        ).finally(() => {
            card.updating = false;
        });
    };

    getKanbanOptions() {
        const kanbanParams: any = {
            c: _.get(this.board, 'config.columnSource.alias', ''),
            r: _.get(this.board, 'config.rowSource.alias', ''),
            excludeReleasedReleases: true,
            collapseEmpty: _.get(this.board, 'config.collapseEmpty', 0)  // auto
        };

        const ret = this.kanbanStrategyService.getOptions(
            kanbanParams,
            this.tracker,
            this.acls
        );

        return ret;
    }

    updateTrackerItem(options, to, from) {
        _.set(
            to,
            options.columns.valuePath,
            _.get(from, options.columns.valuePath)
        );

        return _.set(
            to,
            options.rows.valuePath,
            _.get(from, options.rows.valuePath)
        );
    }

    fetchTrackeritemsForQuery(queryId: any = null) {
        return this.trackeritemRest.fetch(0, { query: queryId, page_size: this.maxCards })
            .then((response: any) => {
                return _.has(response, 'items') && Array.isArray(response.items) ? response.items : [response];
            });
    }

    getTiListArgs(project, sprint, params) {
        var tiList = {
            project: _.get(project, 'id', 0),
            sprint: _.get(sprint, 'id', 0),
            page_num: _.get(params, 'page_num', 1),
            page_size: _.get(params, 'page_size', 20)
        },
            status = _.get(params, 'status', '');

        if (status == -3 || status == -4) {
            tiList['status'] = status;
        }

        if (sprint && sprint.sprintStatus == 2) {
            tiList['sort_field'] = _.get(params, 'sort_field', 'closeDate');
            tiList['sort_dir'] = _.get(params, 'sort_dir', 'asc');
        } else {
            tiList['sort_field'] = _.get(params, 'sort_field', 'priority');
            tiList['sort_dir'] = _.get(params, 'sort_dir', 'desc');
        }

        return tiList;
    }

    fetchTrackeritemsForSprint(params: any = {}) {
        if (_.isEmpty(params)) {
            params = this.stateService.params;
        }

        return this.trackerFilterService.performSearch(
            this.getTiListArgs(this.project, this.sprint, this.stateService.params)
        );
    }

    fetchTrackeritemsForRelease(releaseId: any = null) {
        var params = this.frsReleaseHelper.trackerItems.getFetchParams(this.project);
        return this.trackerFilterService.performSearch(params);
    }
};